import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { List } from './List';
import { AddEdit } from './AddEdit';
import { EditReservation } from './EditReservation';
//import { EditArea } from './EditArea';
import { Search } from './Search';

function Reservations({ match }) {
    const { path } = match;
    
    return (
        <Switch>
            <Route exact path={path} component={Search} />
            <Route path={`${path}/list/:searchstring`} component={List} />
            <Route path={`${path}/add`} component={AddEdit} />
            <Route path={`${path}/edit/:id`} component={AddEdit} />
            <Route path={`${path}/edit_reservation/:id`} component={EditReservation} />
        </Switch>
    );
}

export { Reservations };